import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import * as contexts from '../contexts'

import { Api } from './api.service'
import type { TypeParams } from './types'

/**
 * Collection of {@link Entity} (based on
 * {@link ents.core.mosaic.Page})
 * TODO: This should also retrieve prebuilt pages
 */
@ngCore.Injectable({ providedIn: 'root' })
export class Collection extends ec.Collection<TypeParams> {
  constructor() {
    super({
      api: ngCore.inject(Api),
      context$: ngCore.inject(contexts.Feature).selectors.zoneContext
        .asObservable,
      identify: page => page.id,
      name: ec.Name.Predefined.AdminPage,
      plugins: {
        additionalFactories: [
          new ds.input.select.singleEc.ec.Factory<TypeParams>({
            getItem: ({ name, id }) => ({
              label: name,
              value: id,
            }),
          }),
        ],
      },
    })
  }
}
